import { render, staticRenderFns } from "./UserModalAdd.vue?vue&type=template&id=38752e67&scoped=true&"
import script from "./UserModalAdd.vue?vue&type=script&lang=js&"
export * from "./UserModalAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38752e67",
  null
  
)

export default component.exports